export default __webpack_public_path__ + "static/media/aleska.ba5a3b5c.jpg";